<template lang="pug">
  main
    NavBarIRGE
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.is-multiline.section-title.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Aplicaciones IRGE&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark.is-mobile
          .column.is-3-desktop.is-4-mobile(v-show="verSCA")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-invoice-dollar.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 SCA_IRGE
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/IRGE/SCA/") Entrar
          .column.is-3-desktop.is-4-mobile(v-show="verMonitor")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-industry.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Monitoreo
                br
                a.button.is-dark.is-rounded(@click="irMonitoreo") Entrar
          .column.is-3(v-show="verInventarios")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-cart-arrow-down.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Inventario
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to='/Inventario/Almacenes') Entrar
          .column.is-3(v-show="verReportes")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Reportes
                br
                a.button.is-dark.is-rounded(@click="irReportes") Entrar
</template>    
</template>

<script>
import Loader from "@/components/shared/Loader.vue"
import NavBarIRGE from "@/components/layout/NavBarIRGE.vue"
import NotificacionConst from "@/components/shared/NotificacionConst.vue"
import InventarioServices from "@/services/inventario/inventario"
import ticketServices from "@/services/soporte/tickets"
import { mapState } from "vuex"

export default {
  name: "HomeIRGE",
  components: { Loader, NavBarIRGE, NotificacionConst },
  data() {
    return {
      isLoading: false,
      verGIA: false,
      verCombustible: false,
      verReportes: false,
      verSCA: false,      
      verRequisiciones: false,
      verResponsivas: false,
      verMonitor: false,
      verInventarios: false,
      textosNotificaciones: [
        {
          titulo: "Proyecto",
          fecha: "fecha Pendiente",
          texto: "En proceso de validación,",
          tipo: "sc"
        },
        {
          titulo: "En contrucción",
          fecha: "Junio 2020",
          texto: "Última Act.",
          tipo: "c"
        },
        {
          titulo: "En contrucción",
          fecha: "Septiembre 2019",
          texto: "Última Act.",
          tipo: "c"
        },
        {
          titulo: "Proyecto",
          fecha: "fecha Pendiente",
          texto: "Sin conexión,",
          tipo: "sc"
        },
        {
          titulo: "Proyecto",
          fecha: "fecha Pendiente",
          texto: "En proceso de validación,",
          tipo: "sc"
        }
      ],
      tieneAsignaciones: false,
      isAlmacenistaCede: false,
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push("/")
      } else {
        switch (this.userLogin.cargo) {
          case "000":
            console.log("000 - admin")
            this.verSCA = true
            this.verMonitor = true
            break
          case "001":
            console.log("001 - gerente")
            this.verSCA = true
            this.verMonitor = true
            break
          case "002":
            console.log("002 - gerenteAdmin")
            this.verInventarios = true
            this.verRequisiciones = true
            this.verResponsivas =true
            break
          case "003":
            console.log("002 - Gerente GIA")
            this.isAdminUser = true
            this.verMonitor = true
            break
          case "120":
            console.log("120 - AsistenteIRGE")
            this.isAsistUser = true
            this.verInventarios = true
            this.verResponsivas = true
            this.verRequisiciones = true
            this.verCombustible = true
            break
          case "310":
            console.log("310 - Instrumentista IRGE")
            this.verGIA = true
            this.verInventarios = true
            this.verMonitor = true
            break
          case "321":
            console.log("321 - Almacenista IRGE")
            this.verInventarios = true
            this.isAlmacenistaCede = true
            break
          case "330":
            console.log("330 - sistemasUser")
            this.verGIA = true
            this.verInventarios = true
            this.verMonitor = true
            break
          case '331':
            console.log('331 - Almacenista GIA')
            this.verGIA = true
            this.verInventarios = true
            this.verMonitor = true
            break
          case '332':
            console.log('332 - Sistemas Almacenista')
            this.verGIA = true
            this.verInventarios = true
            this.verMonitor = true
            break
          case "240":
            console.log("240 - Jefe Operaciones")
            this.verMonitor = true
            this.verSCA = true
            break
          case "241":
            console.log("240 - Jefe Operaciones")
            this.verInventarios = true
            this.verMonitor = true
            break
          case "340":
            console.log("340 - Monitoreo")
            this.verMonitor = true
            switch (currentHost) {
              case 'ducter.com.mx':
                this.verSCA = false
                break
              case '10.121.40.125':
                this.verSCA = false
                break
              case '201.132.87.234':
                this.verSCA = false
                break
              default:
                this.verSCA = true
                break
            }
            break
          case "341":
            console.log("341 - facturacion")
            switch (currentHost) {
              case 'ducter.com.mx':
                this.verSCA = false
                break
              case '10.121.40.125':
                this.verSCA = false
                break
              case '201.132.87.234':
                this.verSCA = false
                break
              default:
                this.verSCA = true
                break
            }
            break
          case "342":
            console.log("342 - bascula")
            switch (currentHost) {
              case 'ducter.com.mx':
                this.verSCA = false
                break
              case '10.121.40.125':
                this.verSCA = false
                break
              case '201.132.87.234':
                this.verSCA = false
                break
              default:
                this.verSCA = true
                break
            }
            break
          case "343":
            console.log("343 - bascula y facturacion")
            switch (currentHost) {
              case 'ducter.com.mx':
                this.verSCA = false
                break
              case '10.121.40.125':
                this.verSCA = false
                break
              case '201.132.87.234':
                this.verSCA = false
                break
              default:
                this.verSCA = true
                break
            }
            break
          case "350":
            console.log("350 - mantenimiento")
            // this.isMantenimientoUser = true
            this.verInventarios = true
            break
          case "250":
            console.log("250 - mantenimiento")
            // this.isMantenimientoUser = true
            this.verInventarios = true
            break
          case "370":
            console.log("370 - seguridad")
            switch (currentHost) {
              case 'ducter.com.mx':
                this.verSCA = false
                break
              case '10.121.40.125':
                this.verSCA = false
                break
              case '201.132.87.234':
                this.verSCA = false
                break
              default:
                this.verSCA = true
                break
            }
            break
          case "270":
            console.log("270 - seguridad")
            this.verInventarios = true
            break
          case "430":
            console.log("430 - pasante Sistemas")
            this.verGIA = true
            break
          case "410":
            console.log("410 - Pasante Instrumentacion")
            this.verGIA = true
            break
          case '321':
            console.log('321 - Aduana')
            this.verInventarios = true
            break

          default:
            console.log("NINGUNO")
            this.verGIA = false
            this.verCombustible = false
            this.verReportes = false
            this.verResponsivas = false
            this.verRequisiciones = false
            this.verMonitor = this.permisos.monitoreo != 2
            this.verInventarios = false
            this.verSCA = this.permisos.sca_irge != 2
            break
        }
      }
      //this.checkSolicitudesPendientes()

      if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
        this.checkTickets()
      }
    },
    irSca() {
      location.href = ""
    },
    irReportes() {
      location.href = "/reportesApp/home.html"
    },
    irMonitoreo() {
      console.log("Ir a monitorear" + this.estacionSel)
      this.$router.push("/Monitor")
    },
    checkSolicitudesPendientes() {
      switch (this.userLogin.categoria) {
        case 0:
          console.log("gerentes")
          InventarioServices.getSolicitudes_ubicacion(
            this.userLogin.ubicacion,
            "ALL"
          ).then(res => {
            let sol_depto = res.filter(sol => sol.estado === "2")
            if (sol_depto.length > 0) {
              this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
            }
            this.checkFirmaRequisiciones()
          })
          break
        case 2:
          console.log("jefes de area")
          switch (this.userLogin.departamento) {
            case 1:
              InventarioServices.getSolicitudes_area(this.userLogin.departamento,"ALL")
                .then(res => {
                  let sol_depto = res.filter(sol => parseInt(sol.estado) == 3)
                  if (sol_depto.length > 0) {
                    this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                    this.checkFirmaRequisiciones()
                  }
                })
              break
            case 3:
              InventarioServices.getSolicitudes_area(this.userLogin.departamento,"ALL")
                .then(res => {
                  let sol_depto = res.filter(sol => parseInt(sol.estado) == 3)
                  if (sol_depto.length > 0) {
                    this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                    this.checkFirmaRequisiciones()
                  }
              })
              break

            default:
              InventarioServices.getSolicitudes_depto(this.userLogin.departamento,"ALL")
                .then(res => {
                  let sol_depto = res.filter(sol => sol.estado === "1" && sol.ubicacion === this.userLogin.ubicacion)
                  if (sol_depto.length > 0) {
                    this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                    this.checkFirmaRequisiciones()
                  }
                })
              break
          }
          break
        default:
          break
      }
    },
    checkFirmaRequisiciones() {
      switch (this.userLogin.categoria) {
        case 0:
          console.log("gerentes")
          if (this.userLogin.ubicacion === "ALL") {
            console.log("DUCTO")
            InventarioServices.getRequisiciones_Ubicaciones("CORP", 0)
              .then(res => { 
                console.log(res[0].pendientes)
                let reqPend = parseInt(res[0].pendientes)
                console.log(reqPend)
                if (reqPend > 0) {
                  let textToast = ''
                  if (reqPend == 1) {
                    textToast = `${this.userLogin.nombre} tiene ${reqPend} requisición pendiente.`
                  } else {
                    textToast = `${this.userLogin.nombre} tiene ${reqPend} requisiciones pendientes.`
                  }
                  this.displayToast(textToast,'done','Ir a Requisiciones','/Requisiciones')
                }
              }
            )
          } else if (this.userLogin.cargo === "002") {
            console.log("cargo 002")
            InventarioServices.getRequisiciones_Ubicaciones("ALL", 2)
              .then(res => {
                console.log(res)
                let reqPend = parseInt(res[0].pendientes)
                console.log(reqPend)
                if (reqPend > 0) {
                  let textToast = ''
                  if (reqPend == 1) {
                    textToast = `${this.userLogin.nombre} tiene ${reqPend} requisición pendiente.`
                  } else {
                    textToast = `${this.userLogin.nombre} tiene ${reqPend} requisiciones pendientes.`
                  }
                  this.displayToast(textToast,'done','Ir a Requisiciones','/Requisiciones')
                }
              }
            )
          } else {
            InventarioServices.getRequisiciones_Ubicaciones(this.userLogin.ubicacion,0)
              .then(res => {
                console.log(res)
                let reqPend = parseInt(res[0].pendientes)
                console.log(reqPend)
                if (reqPend > 0) {
                  let textToast = ''
                  if (reqPend == 1) {
                    textToast = `${this.userLogin.nombre} tiene ${reqPend} requisición pendiente.`
                  } else {
                    textToast = `${this.userLogin.nombre} tiene ${reqPend} requisiciones pendientes.`
                  }
                  this.displayToast(textToast,'done','Ir a Requisiciones','/Requisiciones')
                }
              })
          }
          break
        case 2:
          console.log("jefes de area")

          if ( this.userLogin.departamento === 1 || this.userLogin.departamento === 3 ) {
            InventarioServices.getRequisiciones_Area(this.userLogin.departamento, 0)
            .then(res => {
              console.log(res)
            })
          } else {
            console.log("No es sistemas ni Intrumentos")
          }
          break
        default:
          break
      }
      this.getFirmaCombustibles()
    },
    displayToast(message, icon, actionText, destiny) {
      let toast = this.$toasted.show(message, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            console.log(destiny)
            this.$router.push(destiny)
            toastObject.goAway(0)
          }
        },
      })
    },
    getFirmaCombustibles() {
      //  1 Para Gerente GIA --- REVISÓ
      //  2 Para Gerente Admón --- AUTORIZÓ 
      InventarioServices.getFirmasPendientes_Comb(this.userLogin.id, 2)
        .then((data) => {
          let pendientes = parseInt(data[0].pendientes)
          if ( pendientes > 0) {
            this.displayToast(1, 'Firma Pendiente', 'Firmas Pendientes', 'Ir a Combustibles', '/Transportes/Combustible/Resumen')
          }
        })
        .catch((e) => console.log(e))
    },
    checkTickets() {
      switch (parseInt(this.userLogin.categoria)) {
        case 0:
          ticketServices.searchAll(this.userLogin.departamento)
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.compra) == 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 2:
          ticketServices.searchTicket_area(this.userLogin.departamento)
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.compra) == 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 3:
          ticketServices.searchTicket_user(this.userLogin.id, 'a')
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) < 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)

            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
      
        default:
          break
      }
    },
    sendNotification_tickets(ticketsPend) {
      if (ticketsPend > 0) {
        let textToast = ''
        if (ticketsPend == 1) {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} ticket pendiente.`
        } else {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} tickets pendientes.`
        }
        this.displayToast(textToast,'done','Ir a Soporte','/Soporte')
      }
    },
    backPage() {
      this.$router.back()
    },
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  },
  created() {
    this.$store.commit('irEstaciones','IRGE')
    this.obtenerUser()
  }
}
</script>

<style lang="css" scoped>
  .image {
    display: inline-block
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }

  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }

</style>


// WEBPACK FOOTER //
// src/components/apartados/ApartadoIRGE.vue